import { TippingLayout } from '../../layouts';
import { Preloader, ErrorsModal } from "../../utils";
import _ from 'lodash';
import Radio from 'backbone.radio';
// import TipFinEmpty from './TipFinEmpty';
import { TipsCollection } from '../index';

const tippingRadio = Radio.channel('tipping');

// TODO: During rollover refactor extending matches

export class TippingTipsLayout extends TippingLayout {

	async initialize() {
		this.rounds = this.getOption('rounds');
		this.venues = this.getOption('venues');
		this.squads = this.getOption('squads');
		this.soo_matches = this.getOption('soo_matches');
		this.fin_matches = this.getOption('fin_matches');
		this.liveScoresIntervalId = null;

		Preloader.show();

		await this.getJSON();

		this.processRounds();

		this.current_round = await this.getCurrentRound();

		this.setListeners();

		tippingRadio.trigger('show:controls', {
			rounds: this.rounds,
			current_round: this.current_round
		});

		tippingRadio.trigger('tips:round:change',
			this.current_round.get('status')
		);

		await this.getMatches();
		this.checkRoundStatus();
		Preloader.hide();
	}

	/**
	 * @override
	 * @description Do not remove. This method is required for override.
	 */
	processRounds(){
		this.rounds.setFinalRound();
		return this;
	}

	async getCurrentRound(){
		await this.collection.setMatchesUrl().getData({
			data: { round: this.rounds.last_completed.get('id') }
		});

		this.current_round = this.rounds.last_completed;

		await this.getMatches();
		this.addFinalMatchesToCurrentRound();

		const extended_matches = this.extendMatches();
		const has_uncompleted_matches = _.some(
			_.values(extended_matches), match => match.status !== 'complete'
		);


		return has_uncompleted_matches ? this.rounds.last_completed : this.rounds.actual;
	}

	setListeners() {
		this.listenTo(
			this.collection,
			'user:tips:success',
			_.flow([
				this.addFinalMatchesToCurrentRound,
				this.extendMatches, this.initViews
			])
		);

		this.listenTo(tippingRadio, 'autopick', this.autoPick);
		this.listenTo(tippingRadio, 'change:round', this.changeRound);

		this.listenTo(
			this.collection,
			'autopick:tips:success',
			() => tippingRadio.trigger('saved')
		);

		this.listenTo(this.collection, 'autopick:tips:errors', ErrorsModal.show);
		this.listenTo(this.collection, 'user:tips:errors', ErrorsModal.show);
	}

	async changeRound({ round_id }) {
		this.current_round = this.rounds.get(round_id);

		tippingRadio.trigger(
			'tips:round:change',
			this.current_round.get('status')
		);

		Preloader.show();

		await this.getMatches();
		this.checkRoundStatus();
		Preloader.hide();
	}

	async getJSON() {
		const requests = _.invokeMap(
			_.pick(
				this,
				'squads',
				'rounds',
				'venues',
				'soo_matches',
				'fin_matches'
			),
			'fetch'
		);

		return Promise.all(requests);
	}

	async autoPick() {
		Preloader.show();

		const { result, errors } = await this.collection.setAutoPickUrl().postData({
			data: { round: this.current_round.get('id') },
			type: 'autopick:tips'
		});

		if (!_.size(errors)) {
			this.collection.reset(result);
			this.collection.trigger('user:tips:success');
		}

		Preloader.hide();
	}

	async getMatches() {
		const
			round = this.current_round.get('id'),
			is_final = this.current_round.get('is_final');
		if(is_final) {
			await this.getFinalsJson();
		}
		return this.collection.checkIsFinal(is_final).setMatchesUrl().getData({
			data: { round },
			type: 'user:tips'
		});

	}

	addFinalMatchesToCurrentRound() {
		const is_final = this.current_round.get('is_final');
		const current_round_id = this.current_round.get('id');


		if (!is_final) {
			return this;
		}
		const fin_matches_all = this.fin_matches.toJSON();
		// TODO: NRLTB-115 temporary solution. Remove all round besides 21
		const fin_matches = fin_matches_all.filter(match => match.round === current_round_id);
		const matches = this.current_round.get('matches').slice(fin_matches.length);

		this.current_round.set('matches', fin_matches.concat(matches));
	}
	// checkIsSooMatches() {
	// 	const
	// 		last_completed_round = this.rounds.last_completed,
	// 		matches = last_completed_round.get('matches').map(match => ({
	// 			...match,
	// 			is_soo: false
	// 		}));
	// 		// matches_obj = _.keyBy(matches, 'id'),
	// 		// user_tips_obj = _.keyBy(this.collection.toJSON(), 'id');
	//
	// 	this.soo_matches.each((match) => {
	//
	// 		console.log(match.id);
	// 		console.log(matches);
	// 		console.log(this.soo_matches);
	// 		console.log('---------------------------');
	//
	// 		if(matches[match.id]) {
	//
	// 		}
	// 	});
	//
	// 	return false;
	// }

	extendMatches() {
		const
			queensland_squad_id = 500147,
			matches = this.current_round.get('matches').map(match => ({
				...match,
				is_soo: false
			})),
			matches_obj = _.keyBy(matches, 'id'),
			user_tips_obj = _.keyBy(this.collection.toJSON(), 'id');

		this.soo_matches.each((match, index) => {
			if(user_tips_obj[match.id]) {
				const is_queensland_at_home = _.eq(
					match.get('home_squad_id'),
					queensland_squad_id
				);

				_.merge(
					user_tips_obj[match.id],
					match.toJSON(),
					{
						is_soo: true,
						soo_game_index: index + 1,
						is_queensland_at_home
					}
				);
			}
		});

		return _.sortBy(_.merge(matches_obj, user_tips_obj), 'date');
	}

	initViews(user_tips) {
		const
			tips = _.values(user_tips),
			selected_tips = tips.filter(
				tip => tip.predict_winner_squad_id && !tip.is_autogenerate
			),
			total_tips_count = _.size(tips),
			selected_tips_count = _.size(selected_tips);
		tippingRadio.trigger('tips:count', { selected_tips_count, total_tips_count });
		tippingRadio.trigger('user:tips', selected_tips);

		this.initTipsCollection({
			user_tips,
			selected_round_id: this.current_round.get('id'),
			is_final: this.current_round.get('is_final')
		});

		return this;
	}

	initTipsCollection(args) {
		// const { is_final, status } = this.current_round.toJSON();
		if (this.getRegion('content')) {
			this.getRegion('content').show(new TipsCollection());
			this.getChildView('content').init(args);
		}
		// this.getChildView('content').init(args);

		// if(is_final && status === 'scheduled') {
		// 	this.getRegion('content').show(new TipFinEmpty());
		// }
		// else {
		// 	this.getRegion('content').show(new TipsCollection());
		// 	this.getChildView('content').init(args);
		// }

		return this;
	}

	async getFinalsJson() {
		const requests = _.invokeMap(
			_.pick(
				this,
				'fin_matches'
			),
			'fetch'
		);

		return Promise.all(requests);
	}

	checkRoundStatus() {
		if (this.current_round.is_active) {
			this.subscribeToLiveUpdates();
		}
		else if (this.liveScoresIntervalId) {
			this.unsubscribeFromLiveUpdates();
		}
		return this;
	}

	subscribeToLiveUpdates() {
		clearTimeout(this.liveScoresIntervalId);

		const { 
			rounds, 
			fin_matches 
		} = this.options;

		let time = this.current_round.active_match ? 1 : 5;

		this.liveScoresIntervalId = setTimeout(async () => {
			const requests = _.invokeMap([
				rounds, 
				fin_matches
			], 'fetch');

			await Promise.all(requests);

			this.collection.trigger('user:tips:success');

			this.checkRoundStatus();
		}, time * 1000 * 60);

	}

	unsubscribeFromLiveUpdates() {
		clearTimeout(this.liveScoresIntervalId);
	}
}

export default TippingTipsLayout;